import axios from "src/service/axios_c";
import Quote from "@system/config/quote";
import Auth from "@system/config/auth";
import Base from "./Base";
import QuoteDetailAPICall from "./QuoteDetailAPICall";
import { __set, __remove } from "src/store/axios_indicator";
import openQuoteAPICallResponseMaker from "./QuoteAPICall/openQuoteAPICallResponseMaker";
import Helper from "src/support/Helper";

class OpenQuoteAPICall extends Base {
    addQuote = async (params) => {
        let res = {};
        await this.axiosCall(Quote.ADD_QUOTE, params, 'post', true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    addQuoteInBulk = async (params) => {
        let res = {};
        await this.axiosCall(Quote.ADD_QUOTE_IN_BULK, params, 'post', true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };

    sendSubmittedQuoteEmail = async (params) => {
        let res = {};
        __set('QUOTE_API_CALL');
        await this.axiosCall(Quote.SUBMITTED_QUOTE_EMAIL, params).then((resHer) => {
            if (resHer.data !== undefined && resHer.data.data !== undefined) {
                res = resHer.data.data;
            }
            __remove('QUOTE_API_CALL');
        });
        return res;
    };

    clearAllQuote = async () => {
        let res = {};
        await this.axiosCall(Quote.CLEAR_ALL_QUOTE, {}, 'delete').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };

    clearSingleQuote = async (quoteId) => {
        let res = {};
        await this.axiosCall(Quote.CLEAR_SINGLE_QUOTE, {
            lineItemId: quoteId
        }, 'delete').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };

    editQuote = async (params) => {
        let Obj = { items: [] };
        Obj.items.push(params[0].params);
        let res = {};
        await this.axiosCall(Quote.EDIT_QUOTE, Obj, 'put', true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };

    axiosCall = async (url, data = {}, method = 'post', skipParams = false) => {
        data = await this.mergeDataWithBase(data);
        let config = {
            method: method,
            url: url,
            headers: Helper.getCommonHeader(method),
            data: data
        };
        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        return axios(config);
    };
    mergeDataWithBase = async (data) => {
        if (!data.userId) {
            data.userId = await Auth.getUserID();
        }
        return {
            ...data
        };
    };

    getQuoteMinPriceBySpeedBoat = async (params = {}) => {
        /* * Patch: Just for ignoring many calls we are doing this.
           * Owner: Rakshit/Devanshi
           * Date: 25/08/2022
           */
        if (window.temp_getQuoteMinPriceBySpeedBoat !== undefined) {
            return window.temp_getQuoteMinPriceBySpeedBoat;
        }
        let res = {};
        params.speedboat = await Auth.getAuthSBoat();

        try {
            await this.axiosCall(Quote.QUOTE_MIN_PRICE_BY_SPEEDBOAT, {
                ...params
            }, 'get').then((resHer) => {
                res = resHer.data.data;
            });
        } catch (e) {
        }
        window.temp_getQuoteMinPriceBySpeedBoat = {};
        window.temp_getQuoteMinPriceBySpeedBoat = res;
        return res;
    };

    submitQuote = async (params = {}) => {
        let res = {};
        await this.axiosCall(Quote.SUBMIT_QUOTE, params, 'POST', true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };

    getSubmittedQuoteList = async (params = {}) => {
        return await new QuoteDetailAPICall().submittedQuoteList(params);
    };


    searchQuote = async (params = {}) => {
        return await new QuoteDetailAPICall().searchQuote(params);
    };

    // New API call for open quote
    getOpenQuoteList = async (params = {}) => {
        let res = {};
        await this.axiosCall(Quote.OPEN_QUOTE_LIST, params).then((resHer) => {
            res = resHer.data;
        });

        let result = await new openQuoteAPICallResponseMaker(res);
        result = await result.process();
        return result.run().get()
    };

    getQuoteReasonList = async () => { // 11360
        let res = {};
        await this.axiosCall(Quote.QUOTE_REASON_LIST, {}, 'GET', true).then((resHer) => {
            res = resHer.data;
        });
        return res
    };


}

export default OpenQuoteAPICall;